import React, {Suspense, Fragment, lazy} from "react"
import PropTypes from "prop-types"
import {connect} from "react-redux"
import {Switch} from "react-router-dom"
import {BrowserRouter as Router} from "react-router-dom"

import {getSession} from "../utils/session"
import ModalLoader from "../components/modal/loader"

import PublicRoute from "./PublicRouter"
import PrivateRoute from "./PrivateRouter"
import routes from "./routes"

const Layout = lazy(() => import("../components/layout/"))
const LoginPage = lazy(() => import("../pages/login"))

const AppRouter = ({isAuthenticated}) => (
  <Fragment>
    <Suspense fallback={<ModalLoader show caption="Mohon Tunggu..." />}>
      <Router>
        <Switch>
          <PublicRoute isAuthenticated={isAuthenticated} path="/" component={LoginPage} exact />
          <PublicRoute
            exact
            path="/login"
            component={LoginPage}
            isAuthenticated={isAuthenticated}
          />
          <Layout>
            {routes.map((route, index) => {
              return (
                route.component && (
                  <PrivateRoute
                    key={index}
                    isAuthenticated={isAuthenticated}
                    path={route.path}
                    exact={route.exact}
                    name={route.name}
                    component={route.component}
                  />
                )
              )
            })}
          </Layout>
        </Switch>
      </Router>
    </Suspense>
  </Fragment>
)

const mapStateToProps = () => {
  const sessionKey = process.env.REACT_APP_SESSION_KEY
  const session = getSession(sessionKey)
  const now = new Date().getTime()
  return {
    isAuthenticated: session ? now < session.expired : false
  }
}

AppRouter.propTypes = {
  isAuthenticated: PropTypes.bool
}

export default connect(mapStateToProps)(AppRouter)
